import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router';

import { Icons } from '@/shared/ui';

import styles from './HubNav.module.css';

const ITEMS = [
  { to: '/app', key: 'nav.home', icon: <Icons.home />, match: /^\/app\/?$/ },
  {
    to: '/app/browse/boards',
    key: 'nav.myBoards',
    icon: <Icons.board />,
    match: /^\/app\/browse\/(boards|team-boards)\/?$/,
  },
  {
    to: '/app/browse/databases',
    key: 'nav.myDatabases',
    icon: <Icons.viewTable />,
    match: /^\/app\/browse\/databases\/?$/,
  },
  {
    to: '/app/browse/workspaces',
    key: 'nav.workspaces',
    icon: <Icons.workspace />,
    match: /^\/app\/browse\/workspaces\/?$/,
  },
] as const;

/**
 * The resource hubs of the app - Home, My Boards, My Databases, Workspaces - as one row
 * of real links (pages, not tabs). The same component sits under the heading of each hub page; on
 * a phone it is one horizontally scrolling strip, so it never wraps or widens the page.
 */
export function HubNav() {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  return (
    <nav className={styles.nav} aria-label={t('nav.hub')} data-testid="hub-nav">
      <ul className={`${styles.list} scroll-strip`}>
        {ITEMS.map((item) => (
          <li key={item.to}>
            <Link
              to={item.to}
              className={styles.link}
              aria-current={item.match.test(pathname) ? 'page' : undefined}
              data-active={item.match.test(pathname) || undefined}
            >
              {item.icon}
              <span>{t(item.key)}</span>
            </Link>
          </li>
        ))}
      </ul>
    </nav>
  );
}
